// extracted by mini-css-extract-plugin
module.exports = {"footer":"NotificationWrite_footer_oxCT6","write":"NotificationWrite_write_1WfF5"};